import { STEP_IDENTIFIER_NAME } from '../constants';
import type { StepConfig } from '../types';

const { AI_RESULTS_DRAFT } = STEP_IDENTIFIER_NAME;

export const aiResultsDraft: StepConfig = {
	name: AI_RESULTS_DRAFT,
	isAuthenticationRequired: false,
	isEnabled: (fcm) => fcm.starterAIPrompt.isEnabled,
};
